export const getOption = (a) => a.replace(/_/g, '')
